import { selectBuildingsInfoByTypeId } from "../../../../../selectors/selectExistingBuildingInfo";
import { utilBuildings } from "../../../../../utils/utilBuildings";
export var checkBuildingConstructionDoneAvailable = function (path) { return function (action, state$, dependencies) {
    var state = state$.value;
    var taskType = action.taskType;
    var availableBuildings = selectBuildingsInfoByTypeId(state, taskType.buildingId);
    return availableBuildings.some(utilBuildings.hasFinishedConstruction) ? path : undefined;
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/show-me/quest-tasks/have-building/checks/checkBuildingConstructionDoneAvailable.ts
// module id = 2373
// module chunks = 3